export const integrationHeroVariants = [
    {
        variant: 'control',
        title: 'Integrate once, launch in days',
    },
    {
        variant: 'test_group_1',
        title: 'Integrate once, build anything',
    },
];
